import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import Icon from '../icon';
var Panel = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames6, _classNames7, _classNames8;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    prefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  var _a = getCompProps('CollapsePanel', userDefaultProps, props),
    disabled = _a.disabled,
    extra = _a.extra,
    assist = _a.assist,
    header = _a.header,
    onChange = _a.onChange,
    panelKey = _a.panelKey,
    innerKey = _a.innerKey,
    bordered = _a.bordered,
    expandIcon = _a.expandIcon,
    expandIconPosition = _a.expandIconPosition,
    style = _a.style,
    title = _a.title,
    className = _a.className,
    children = _a.children,
    customPrefixcls = _a.prefixCls,
    others = __rest(_a, ["disabled", "extra", "assist", "header", "onChange", "panelKey", "innerKey", "bordered", "expandIcon", "expandIconPosition", "style", "title", "className", "children", "prefixCls"]);
  var panelPrefixCls = getPrefixCls(prefixCls, 'collapse-panel', customPrefixcls); // 样式前缀
  var childrenRef = useRef();
  var setHeightTimerRef = useRef(null);
  var setAutoHeightTimerRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expandAnimation = _useState2[0],
    setExpandAnimation = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    expand = _useState4[0],
    setExpand = _useState4[1];
  useEffect(function () {
    var newValue = _includesInstanceProperty(innerKey).call(innerKey, panelKey);
    if (newValue !== expand) {
      setExpand(newValue);
      setExpandAnimation(true);
    }
  }, [innerKey]);
  var handleClick = function handleClick() {
    if (disabled) return;
    onChange && onChange(panelKey);
  };
  var renderIcon = function renderIcon() {
    var _classNames;
    var iconClassName = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(panelPrefixCls, "-icon"), true), _defineProperty(_classNames, "".concat(panelPrefixCls, "-animation-expand"), !expand), _defineProperty(_classNames, "".concat(panelPrefixCls, "-animation-collapse"), expand), _defineProperty(_classNames, "".concat(panelPrefixCls, "-disabled"), disabled), _classNames));
    return /*#__PURE__*/React.createElement("span", {
      className: iconClassName,
      onClick: handleClick
    }, expandIcon ? renderReactNode(expandIcon) : /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-right-solid"
    }));
  };
  var renderLeft = function renderLeft() {
    var _classNames2, _classNames3;
    var className = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(panelPrefixCls, "-left"), true), _defineProperty(_classNames2, "".concat(panelPrefixCls, "-disabled"), disabled), _classNames2));
    var headerClassName = classNames((_classNames3 = {}, _defineProperty(_classNames3, "".concat(panelPrefixCls, "-header"), true), _defineProperty(_classNames3, "".concat(panelPrefixCls, "-disabled"), disabled), _classNames3));
    return /*#__PURE__*/React.createElement("span", {
      className: className,
      onClick: handleClick
    }, expandIconPosition === 'left' ? renderIcon() : null, header && /*#__PURE__*/React.createElement("span", {
      className: headerClassName,
      title: title
    }, renderReactNode(header)));
  };
  var renderRight = function renderRight() {
    var _classNames4;
    var className = classNames((_classNames4 = {}, _defineProperty(_classNames4, "".concat(panelPrefixCls, "-right"), true), _defineProperty(_classNames4, "".concat(panelPrefixCls, "-disabled"), disabled), _classNames4));
    return /*#__PURE__*/React.createElement("span", {
      className: className
    }, extra && /*#__PURE__*/React.createElement("span", {
      className: "".concat(panelPrefixCls, "-extra")
    }, renderReactNode(extra)), expandIconPosition === 'right' ? renderIcon() : null);
  };
  var renderMiddle = function renderMiddle() {
    var _classNames5;
    var className = classNames((_classNames5 = {}, _defineProperty(_classNames5, "".concat(panelPrefixCls, "-middle"), true), _defineProperty(_classNames5, "".concat(panelPrefixCls, "-disabled"), disabled), _classNames5));
    return /*#__PURE__*/React.createElement("span", {
      className: className
    }, assist && /*#__PURE__*/React.createElement("span", {
      className: "".concat(panelPrefixCls, "-assist")
    }, renderReactNode(assist)));
  };
  var renderReactNode = function renderReactNode(reactNode) {
    if (typeof reactNode === 'function') {
      return reactNode();
    }
    return reactNode;
  };
  var rootClassName = classNames(className, (_classNames6 = {}, _defineProperty(_classNames6, "".concat(panelPrefixCls), true), _defineProperty(_classNames6, "".concat(panelPrefixCls, "-border"), bordered), _defineProperty(_classNames6, "".concat(panelPrefixCls, "-opened"), expand), _classNames6));
  var topClassName = classNames((_classNames7 = {}, _defineProperty(_classNames7, "".concat(panelPrefixCls, "-top"), true), _defineProperty(_classNames7, "".concat(panelPrefixCls, "-disabled"), disabled), _defineProperty(_classNames7, "".concat(panelPrefixCls, "-top-border"), bordered && expand), _classNames7));
  var childrenClassName = classNames((_classNames8 = {}, _defineProperty(_classNames8, "".concat(panelPrefixCls, "-children"), expand), _defineProperty(_classNames8, "".concat(panelPrefixCls, "-children-hide"), !expand), _classNames8));
  var childrenBorderedClassName = classNames(_defineProperty({}, "".concat(panelPrefixCls, "-children-bordered"), bordered));
  var runExpandAnimation = function runExpandAnimation(element) {
    element.style.height = '0px';
    element.style.opacity = '0';
    setHeightTimerRef.current && clearTimeout(setHeightTimerRef.current);
    setHeightTimerRef.current = setTimeout(function () {
      element.style.display = 'block';
      element.style.opacity = '1';
      element.style.height = "".concat(element.scrollHeight, "px");
    }, 10);
    setAutoHeightTimerRef.current && clearTimeout(setAutoHeightTimerRef.current);
    setAutoHeightTimerRef.current = setTimeout(function () {
      element.style.height = 'auto';
    }, 350);
  };
  var runCollapseAnimation = function runCollapseAnimation(element) {
    setAutoHeightTimerRef.current && clearTimeout(setAutoHeightTimerRef.current);
    element.style.height = "".concat(element.scrollHeight, "px");
    setAutoHeightTimerRef.current = setTimeout(function () {
      element.style.height = '0px';
      element.style.opacity = '0';
    }, 0);
  };
  var expandWidthoutAnimation = function expandWidthoutAnimation(element) {
    element.style.height = 'auto';
    element.style.opacity = '1';
  };
  var panelPrefixClsRef = ref || /*#__PURE__*/React.createRef();
  React.useLayoutEffect(function () {
    if (!childrenRef.current) return;
    if (expandAnimation) {
      expand ? runExpandAnimation(childrenRef.current) : runCollapseAnimation(childrenRef.current);
      setExpandAnimation(false);
    } else if (!expandAnimation) {
      expand ? expandWidthoutAnimation(childrenRef.current) : runCollapseAnimation(childrenRef.current);
    }
  }, [childrenRef.current, expandAnimation, expand]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClassName,
    style: style,
    ref: panelPrefixClsRef
  }, others), /*#__PURE__*/React.createElement("span", {
    className: topClassName
  }, renderLeft(), renderMiddle(), renderRight()), /*#__PURE__*/React.createElement("div", {
    className: childrenClassName,
    ref: childrenRef
  }, /*#__PURE__*/React.createElement("div", {
    className: childrenBorderedClassName
  }, children)));
});
Panel.displayName = 'Panel';
export default Panel;